export default __webpack_public_path__ + "static/pra-1e0a738355315ab1975dd8c40eb936d7.png";